export const globalPromotionsManager = {
  header: {
    title: "Menedżer promocji",
    description:
      "Twórz promocje pobytowe dla całego konta i zarządzaj nimi. Będą dostępne we wszystkich obiektach (apartamentach i hotelach).",
  },

  toolbar: {
    info: "Promocje utworzone w tym miejscu można włączyć w zakładce <strong>Promocje</strong> każdego obiektu.",
    newPromotion: "Nowa promocja",
  },

  loading: "Wczytywanie promocji...",
  close: "Zamknij",
  cancel: "Anuluj",
  noLimit: "Bez limitu",

  status: {
    active: "Aktywna",
    paused: "Wstrzymana",
  },

  card: {
    stay: "Pobyt",
    discount: "Rabat",
    validity: "Ważność",
    edit: "Edytuj",
    delete: "Usuń",
  },

  nights: {
    range: "{min} – {max} nocy",
    min: "{min}+ nocy",
  },

  discount: {
    fixed: "{value} (stała kwota)",
  },

  empty: {
    title: "Brak utworzonych promocji",
    description:
      "Twórz promocje, które zachęcą do dłuższych pobytów. Możesz je włączyć w każdym obiekcie w ustawieniach rezerwacji bezpośrednich.",
    create: "Utwórz pierwszą promocję",
  },

  form: {
    editTitle: "Edytuj promocję",
    createTitle: "Nowa promocja",
    nameLabel: "Nazwa promocji",
    namePlaceholder: "np. Rabat na 7 nocy, Oferta tygodniowa",
    minNights: "Minimalna liczba nocy",
    maxNights: "Maksymalna liczba nocy",
    optional: "(opcjonalnie)",
    noLimitPlaceholder: "Bez limitu",
    discountType: "Rodzaj rabatu",
    percentage: "Procentowy",
    fixedAmount: "Kwota stała",
    discountValue: "Wartość rabatu",
    amountSuffix: "kwota",
    validFrom: "Ważna od",
    validTo: "Ważna do",
    activateNow: "Włącz promocję od razu",
    propertiesLabel: "Obiekty, w których będzie dostępna",
    selectAll: "Zaznacz wszystkie",
    propertiesHelper:
      "Dla wybranych obiektów zostaną utworzone wpisy konfiguracyjne.",
    infoBox:
      "Plakietkę, kolejność i zachowanie można później dostosować w zakładce <strong>Promocje</strong> każdego obiektu.",
    saving: "Zapisywanie...",
    update: "Zaktualizuj",
    create: "Utwórz promocję",
  },

  deleteModal: {
    title: "Usuń promocję",
    warningStrong: "Tej operacji nie można cofnąć.",
    warningBefore: "Zaraz zostanie usunięta promocja",
    warningAfter: ". Nie będzie już dostępna w żadnym obiekcie.",
    confirmLabel: "Wpisz dokładną nazwę, aby potwierdzić:",
    confirmPlaceholder: "Wpisz nazwę promocji",
    deleting: "Usuwanie...",
    confirmDelete: "Usuń trwale",
  },

  toasts: {
    loadError: "Nie udało się wczytać promocji.",
    nameRequired: "Podaj nazwę promocji",
    minNightsWarning: "Minimalna liczba nocy musi wynosić co najmniej 1",
    discountValueWarning: "Wartość rabatu musi być większa niż 0",
    selectProperty: "Wybierz co najmniej jeden obiekt",
    updated: "Promocja zaktualizowana",
    created: "Promocja została utworzona",
    saveFailed: "Nie udało się zapisać",
    saveError: "Błąd podczas zapisywania promocji",
    deleted: "Promocja usunięta",
    deleteFailed: "Nie udało się usunąć",
    deleteError: "Błąd podczas usuwania",
  },
};
